import { Api } from 'laravel-request';

/**
 * @param {object} item — { id, type_id, custom_type_id, sign, is_unique }
 * @param {object} client
 * @param {{ onSuccess?: (response: unknown) => void, onError?: () => void }} [options]
 */
export const updateActiveType = (item, client, options = {}) => {
  Api.putArg('active', 'type', item.id, {
    type_id: item.type_id,
    custom_type_id: item.custom_type_id,
    sign: item.sign,
    is_unique: item.is_unique,
    user_id: client?.id || '',
  }).call(
    (response) => {
      options.onSuccess?.(response);
    },
    () => {
      options.onError?.();
    }
  );
};
